import { authState, getFirstAccessibleRoute, processNodeAndPermissions } from "../../../helper/com-helper";
import { OM } from "./OM";
import { TMS } from "./TMS";

const IEO_OBJECT = {
  name: "Intelligent Execution Orchestration",
  route: "/tms",
  permissions: [],
  child: {
    "iTMS": TMS,
    "Order Management": OM,
  }
};

IEO_OBJECT.route = authState.permissions.includes("LOAD_PLAN_VIEW")
  ? "/tms"
  : getFirstAccessibleRoute(IEO_OBJECT) ?? "/tms";

processNodeAndPermissions(IEO_OBJECT);
export const IEO = IEO_OBJECT;
